export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5524.71e93417.jpg";